// extracted by mini-css-extract-plugin
export var dropdownButton = "_10-0";
export var fullWidthDropdownButton = "_10-1";
export var icon = "_10-3";
export var iconPlaceholder = "_10-2";
export var menuItemRow = "_10-9";
export var separator = "_10-e";
export var shortcutContainer = "_10-7";
export var shortcutContainerFilled = "_10-8";
export var shortcutIconLg = "_10-6";
export var shortcutIconMd = "_10-5";
export var shortcutIconSm = "_10-4";
export var submenuChevron = "_10-d";
export var submenuDropdown = "_10-a";
export var submenuTriggerRow = "_10-b";
export var submenuTriggerRowOpen = "_10-c";